import { CREATE_EXTENSION_HISTORIES, UPDATE_EXTENSION_HISTORIES, SET_LIST_EXTENSION_HISTORIES, SET_EXTENSION_HISTORIES} from "../../reducerTypes"

const initialState = {
  getData: {},
  getList: []
}

const extensionReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_LIST_EXTENSION_HISTORIES:
      return{
        ...state,
        getList: action.payload
      }
    case SET_EXTENSION_HISTORIES:
      return{
        ...state,
        getData: action.payload
      }
    case UPDATE_EXTENSION_HISTORIES:
      return{
        ...state,
        getData: action.payload
      }
    // case CREATE_LESSON:
    //   return{
    //     ...state,
    //     currentInstuctor: action.payload
    //   }
    default:
      return state
  }
}

export default extensionReducer
